const api = {
    // imgUploadUrl: "http://192.168.50.68:8080/api/mgr/upload",
    // imgBaseUrl: "http://192.168.50.68:9000/gxhts/",
    imgUploadUrl: "/api/mgr/upload",
    imgBaseUrl: process.env.VUE_APP_API_FILE_URL || "https://miniofile.bolatek.com/gxhts/",
    
    login: "/api/mgr/login",
    logout: "/api/mgr/logout",
    getForgetPasswordPasscode: "/api/mgr/getForgetPasswordPasscode",
    forgetPassword: "/api/mgr/forgetPassword",
    changePassword: "/api/mgr/changePassword",
    loginInfo: "/api/mgr/loginInfo",
    dashboardData: "/api/mgr/dashboardData",

    Management: {
        accountList: "/api/mgr/account/pageList",
        accountAdd: "/api/mgr/account/create",
        accountDelete: "/api/mgr/account/delete/",
        accountDetails: "/api/mgr/account/details/",
        accountStatus: "/api/mgr/account/status/",
        accountUpdate: "/api/mgr/account/update/",
    },
    // Members
    Members: {
        // 单位会员管理
        institutionalList: "/api/mgr/qyuser/pagelist",
        institutionalAdd: "/api/mgr/qyuser/create",
        institutionalAuditing: "/api/mgr/qyuser/auditing/",
        institutionalDelete: "/api/mgr/qyuser/delete/",
        institutionalDetails: "/api/mgr/qyuser/details/",
        institutionalExport: "/api/mgr/qyuser/export",
        institutionalImport: "/api/mgr/qyuser/import",
        institutionalIspay: "/api/mgr/qyuser/ispay/",
        institutionalPreMember: "/api/mgr/qyuser/preMember/",
        institutionalResetrootpass: "/api/mgr/qyuser/resetrootpass/",
        institutionalStatus: "/api/mgr/qyuser/status/",
        institutionalUpdate: "/api/mgr/qyuser/update/",
        resetrootpass: "/api/mgr/qyuser/resetrootpass/",
        // 个人会员管理
        personalList: "/api/mgr/gruser/pageList",
        personalAdd: "/api/mgr/gruser/create",
        personalAuditing: "/api/mgr/gruser/auditingStatus/",
        personalDelete: "/api/mgr/gruser/delete/",
        personalDetails: "/api/mgr/gruser/details/",
        personalExport: "/api/mgr/gruser/export",
        personalImport: "/api/mgr/gruser/import",
        personalResetrootpass: "/api/mgr/gruser/changePassword/",
        personalStatus: "/api/mgr/gruser/status/",
        personalUpdate: "/api/mgr/gruser/update/",
        preMember: "/api/mgr/gruser/preMember/",
        ispay: "/api/mgr/gruser/ispay/",
        expertUpdate: "/api/mgr/gruser/expertUpdate/",
        promisePay: "/api/mgr/gruser/promisePay/",

        // 个人会员统计
        reportExport: "/api/mgr/report/export",
        reportList: "/api/mgr/report/pagelist",
    },
    // ContentManagement
    ContentManagement: {
        // 管理端栏目
        mgrcatList: "/api/mgr/cat/list",
        addMgrcat: "/api/mgr/cat/create",
        deleteMgrcat: "/api/mgr/cat/delete/",
        updateMgrcat: "/api/mgr/cat/update/",
        sortting: "/api/mgr/cat/sortting/",
        // 管理端文章
        articleList: "/api/mgr/article/pagelist",
        articleDetail: "/api/mgr/article/details/",
        articleDeleteComment: "/api/mgr/article/deleteComment/",
        articleDelete: "/api/mgr/article/delete/",
        articleAdd: "/api/mgr/article/create",
        articleAuditing: "/api/mgr/article/auditing/",
        articleCommentList: "/api/mgr/article/pagelistComment",
        articleUpdateStatus: "/api/mgr/article/status/",
        articleUpdate: "/api/mgr/article/update/",
        articleTopshow: "/api/mgr/article/topshow/",
        // 链接管理
        linksList: "/api/mgr/links/list",
        linksAdd: "/api/mgr/links/create",
        linksDelete: "/api/mgr/links/delete/",
        linksUpdate: "/api/mgr/links/update/"
    },
}

export default api